import { dataAccuracyService } from "../../../../services/api/data-accuracy.endpoints";
import {
  setAllUsers,
  setDisplayErrorSnackBar,
} from "../../../../features/userSlice";
import store from "../../../../store";
import {
  setDataAccuracyList,
  setIsSuccess,
  setSingleRowData,
  setAllDimensions,
  setDataAccruracyData,
  setTasksByTaskStructureSharedUid,
} from "../../../../features/dataAccuracySlice";

async function getAllDataAccuracyList(oauthTokenHeader: any, dispatch: any) {
  try {
    const response =
      await dataAccuracyService.getDataAccuracyTasks(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get accuracy list");
    } else {
      dispatch(setDataAccuracyList(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getDataAccuracyByWebsiteOrDimensionOrOrganization(
  queryId: any,
  oauthTokenHeader: any,
  type: any,
  website_shared_uids: string[] = [],
  dimensions: string[] = [],
  dispatch: any,
) {
  try {
    const response =
      await dataAccuracyService.getDataAccuracyByWebsiteOrDimensionOrOrganization(
        queryId,
        oauthTokenHeader,
        type,
        website_shared_uids,
        dimensions,
      );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get accuracy list");
    } else {
      dispatch(setDataAccruracyData(response?.data?.data));
    }
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: error?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getAllDimensions(oauthTokenHeader: any, dispatch: any) {
  try {
    const response =
      await dataAccuracyService.getAllDimensions(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get accuracy list");
    } else {
      dispatch(setAllDimensions(response?.data?.data));
    }
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: error?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function singleDataAccuracyTask(
  oauthTokenHeader: any,
  task_shared_uid: any,
  dispatch: any,
  navigate: any,
) {
  try {
    const response = await dataAccuracyService.getDataAccuracyTask(
      oauthTokenHeader,
      task_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      dispatch(setSingleRowData(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
    navigate("/operations/data_accuracy");
  }
}

async function updateDataAccuracyTask(
  oauthTokenHeader: any,
  data: any,
  dispatch: any,
) {
  try {
    const response = await dataAccuracyService.updateDataAccuracyTask(
      oauthTokenHeader,
      data,
    );
    if (!response || !response.status || response.status !== 207) {
      return response;
    } else {
      dispatch(setIsSuccess(true));
    }
  } catch (e: any) {
    dispatch(setIsSuccess(false));
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}
async function updateDataAccuracyTaskSingle(
  oauthTokenHeader: any,
  data: any,
  task_shared_uid: any,
) {
  try {
    const response = await dataAccuracyService.updateDataAccuracyTaskSingle(
      oauthTokenHeader,
      data,
      task_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update content");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Edited Successfully",
          type: "success",
        }),
      );
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function commentDataAccuracyTask(
  oauthTokenHeader: any,
  data: any,
  objectSharedUid: any,
) {
  try {
    const response = await dataAccuracyService.postDataAccruancyComment(
      oauthTokenHeader,
      data,
      objectSharedUid,
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to get page content");
    } else {
      return response?.data?.data; // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getAllUserList(oauthTokenHeader: any) {
  try {
    const response = await dataAccuracyService.getAllUsers(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      store.dispatch(setAllUsers(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getComments(
  oauthTokenHeader: any,
  object_shared_uid: any,
  setComments: any,
) {
  try {
    const response = await dataAccuracyService.getComments(
      oauthTokenHeader,
      object_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      setComments(response?.data?.data);
    }
  } catch (e: any) {
    // store.dispatch(
    //   setDisplayErrorSnackBar({
    //     message: "No Comments Found",
    //     type: "error",
    //   })
    // );
    console.error(e);
  }
}

async function postComments(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any,
) {
  try {
    const response = await dataAccuracyService.postComments(
      oauthTokenHeader,
      data,
      object_shared_uid,
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to get users");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function putComments(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any,
) {
  try {
    const response = await dataAccuracyService.putComments(
      oauthTokenHeader,
      data,
      object_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to edit comments");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function uploadFile(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any,
) {
  try {
    const response = await dataAccuracyService.uploadFile(
      oauthTokenHeader,
      data,
      object_shared_uid,
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to upload files");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getFiles(
  oauthTokenHeader: any,
  object_shared_uid: any,
  setFiles: any,
) {
  try {
    const response = await dataAccuracyService.getFiles(
      oauthTokenHeader,
      object_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get files");
    } else {
      setFiles(response?.data?.data);
    }
  } catch (e: any) {
    // store.dispatch(
    //   setDisplayErrorSnackBar({
    //     message: e?.parsedText || "Unknown error occurred",
    //     type: "error",
    //   })
    // );
    console.error(e);
  }
}

async function getTasksByTaskStructureSharedUid(
  oauthTokenHeader: any,
  task_structure_shared_uid: string,
  website_shared_uid: any,
  dispatch: any,
) {
  try {
    const response = await dataAccuracyService.getTasksByTaskStructureSharedUid(
      oauthTokenHeader,
      website_shared_uid,
      task_structure_shared_uid,
    );

    dispatch(setTasksByTaskStructureSharedUid([]));

    if (response?.status === 204) {
      store.dispatch(
        setDisplayErrorSnackBar({ message: "No tasks found", type: "success" }),
      );
    } else if (response?.status !== 200) {
      throw new Error("Failed to get tasks");
    }

    dispatch(setTasksByTaskStructureSharedUid(response?.data?.data)); // Set the fetched data
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

export const DataAccuracyEndPointLogic = {
  getAllDataAccuracyList,
  singleDataAccuracyTask,
  updateDataAccuracyTask,
  updateDataAccuracyTaskSingle,
  commentDataAccuracyTask,
  getAllUserList,
  getComments,
  postComments,
  putComments,
  uploadFile,
  getFiles,
  getDataAccuracyByWebsiteOrDimensionOrOrganization,
  getAllDimensions,
  getTasksByTaskStructureSharedUid,
};
